<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item name="name">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
              <template v-slot:suffix><search-outlined type="user"/></template>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">
          团队管理
        </p>
        <a-button
          type="primary"
          @click="toTeamEdit('add')"
        >
          添加团队
        </a-button>
      </div>
      <br>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:companyId="{ text }">
          {{ getCompanyName(text) }}
        </template>
        <template v-slot:state="{ text }">
          {{ getState(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="toTeamEdit('detail', record)">查看</a>
          </span>
          <span class="gap-btn">
            <a @click="handleStatus(record)">{{ record.state === 'open' ? '停用' : '启用' }}</a>
          </span>
          <span class="gap-btn">
            <a @click="handleDelete(record)">删除</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.currentPage"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <TeamEdit ref="editDialog"
      :dialogType="dialogType"
      :currentItem="currentItem"
      @update="getData()">
    </TeamEdit>
  </div>
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue'
import { getTeamByPage, deleteTeam, updateTeam } from '@/api/team'
import { getState, getDateTime, getCompanyName } from '@/filters'
import TeamEdit from './TeamEdit'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '公司',
    dataIndex: 'companyId',
    slots: { customRender: 'companyId' }
  },
  {
    title: '电话',
    dataIndex: 'phoneNumber'
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  // {
  //   title: '类型',
  //   dataIndex: 'type'
  // },
  {
    title: '状态',
    dataIndex: 'state',
    slots: { customRender: 'state' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    SearchOutlined,
    TeamEdit
  },
  data () {
    return {
      form: {
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogType: 'add',
      currentItem: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getDateTime,
    getCompanyName,
    getState,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getTeamByPage({ ...this.page, ...this.form }).then(res => {
        const data = res.data.map.data
        this.tableData = data.rows
        this.total = data.total
      })
    },
    toTeamEdit (type, item) {
      this.dialogType = type
      if (type === 'detail') {
        this.currentItem = item
      } else {
        this.currentItem = {}
      }
      this.$refs.editDialog.open()
    },
    handleDelete (record) {
      this.$confirm({
        title: '删除团队',
        content: '确认删除团队？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          deleteTeam(record.id).then(res => {
            this.$message.success('已删除')
            this.getData()
            this.$store.dispatch('updateTeamList')
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    handleStatus (record) {
      this.$confirm({
        title: record.state === 'open' ? '停用团队' : '启用团队',
        content: record.state === 'open' ? '确认停用团队？' : '确认启用团队',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          const params = {
            id: record.id,
            // name: record.name,
            // phoneNumber: record.phoneNumber,
            // email: record.email,
            state: record.state === 'open' ? 'close' : 'open'
          }
          updateTeam(params).then(res => {
            if (res.status === 200) {
              this.$message.success('操作成功')
            }
            this.getData()
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    }
  }
}
</script>
<style>

</style>
